import React, { useState } from "react";

import {
  useListContext,
  useDataProvider,
  useNotify,
  useRefresh,
  SelectInput,
  TextInput,
  DateInput,
  SimpleForm,
} from "react-admin";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

import {
  SEVERITY_CHOICES,
  STATUS_CHOICES,
  ADJUDICATION_CATEGORY_CHOICES,
} from "../consts";

const BulkAdjudicationButton = () => {
  const { selectedIds } = useListContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const [open, setOpen] = useState(false);

  if (!selectedIds || selectedIds.length === 0) return null;

  const handleSubmit = async (values: any) => {
    const payload = {
      ...(values.status && { status: values.status }),
      ...(values.targetFixReleaseVersion && {
        targetFixReleaseVersion: values.targetFixReleaseVersion,
      }),
      ...(values.targetFixReleaseDate && {
        targetFixReleaseDate: values.targetFixReleaseDate,
      }),
      ...(values.targetFixImageTag && {
        targetFixImageTag: values.targetFixImageTag,
      }),
      ...(values.adjudicationSeverity && {
        adjudicationSeverity: values.adjudicationSeverity,
      }),
      ...(values.adjudicationCategory && {
        adjudicationCategory: values.adjudicationCategory,
      }),
      ...(values.adjudicationNotes && {
        adjudicationNotes: values.adjudicationNotes,
      }),
    };

    try {
      await dataProvider.custom(
        "cve/tracked-cves/bulk-update",
        "POST",
        {
          ids: selectedIds,
          data: payload,
        }
      );

      notify("Bulk adjudication successful", { type: "success" });
      refresh();
      setOpen(false);
    } catch (error: any) {
      console.error("Error:", error);
      notify(
        error?.body?.message ||
          error?.message ||
          "Bulk adjudication failed",
        { type: "error" }
      );
    }
  };

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        Bulk Adjudication
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          Bulk Adjudication ({selectedIds.length} items)
        </DialogTitle>

        <SimpleForm onSubmit={handleSubmit} toolbar={false}>
          <DialogContent>
            <SelectInput
              source="status"
              label="Status"
              choices={STATUS_CHOICES}
            />

            <TextInput
              source="targetFixReleaseVersion"
              label="Target Fix Release Version"
              fullWidth
            />

            <DateInput
              source="targetFixReleaseDate"
              label="Target Fix Release Date"
              fullWidth
            />

            <TextInput
              source="targetFixImageTag"
              label="Target Fix Image Tag"
              fullWidth
            />

            <SelectInput
              source="adjudicationSeverity"
              label="Adjudication Severity"
              choices={SEVERITY_CHOICES}
            />

            <SelectInput
              source="adjudicationCategory"
              label="Adjudication Category"
              choices={ADJUDICATION_CATEGORY_CHOICES}
            />

            <TextInput
              source="adjudicationNotes"
              label="Notes"
              multiline
              fullWidth
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button type="submit">Apply</Button>
          </DialogActions>
        </SimpleForm>
      </Dialog>
    </>
  );
};

export default BulkAdjudicationButton;